<template>
    <div class="scroll" style="width: 100%;">
        <div v-for="index in 5">
            <div class="threat-timeline-header col-xs-12" v-if="fetchData">
                {{threatNames.filter(oneData => oneData.enum_no === index)[0].group_name[0]}}
                {{threatNames.filter(oneData => oneData.enum_no === index)[0].group_name[1]}}
            </div>
            <div class="threat-timeline-graph col-xs-10" style="height: 100%; position: relative"
                 v-on:wheel="changeZoomLevel" id="threat-timeline-maximize" @mouseup="mouseUp">
                <div class="graph-time-container" v-if="fetchData">
                    <p>{{graphLabel}} </p>
                </div>
                <threat-time-line-maximize-graph
                    v-if="fetchData"
                    :data="dataForGraph[index-1]"
                    :height="450"
                    @dragHandler="graphDragHandler"
                    :enumNo="index"
                    :largeScreenBoolean="screenBoolean"
                    @rendered="maximizeGraphRender"
                ></threat-time-line-maximize-graph>
            </div>
        </div>
    </div>
</template>

<script>
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import LoadingModal from "@/components/modals/LoadingModal";
    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';

    const TOTAL_FEED_COUNT = 15;
    const TOTAL_WEEKLY_FEED_COUNT = 105;

    import ThreatTimeLineMaximizeGraph from "../../../components/threat-timeline/ThreatTimeLineMaximizeGraph";
    import moment from "moment-timezone";
    import constants from './../../../components/threat-timeline/const';

    export default {
        name: "threat-time-line-maximize",
        components: {
            ThreatTimeLineMaximizeGraph: ThreatTimeLineMaximizeGraph,
            LoadingModal: LoadingModal
        },
        mixins: [Common],
        props: {
            largeScreenBoolean: {
                type: Boolean,
                required: false
            },
            renderedMaximize: {
                type: Function,
                required: false
            }
        },
        data() {
            return {
                loading: false,
                largeScreen: true,
                fetchData: null,
                zoomLevel: 2,
                maxRadius: 0,
                startDay: null,
                endDay: null,
                dataForGraph: [],
                logarithmicBase: 0,
                logarithmicBaseWeekly: [],
                threatNames: [],
                graphDataFromBackend: [],
                graphWeeklyDataFromBackend: [],
                dataForEnumNo1: [],
                dataForEnumNo2: [],
                dataForEnumNo3: [],
                dataForEnumNo4: [],
                dataForEnumNo5: [],
                screenBoolean: null,
                maximizeGraphRendered: false,
                graphLabel: '30 days',
                zoomLevel1DayCount: 14,
                zoomLevel2DayCount: 30,
                zoomLevel3WeekCount: 12,
                zoomLevel4WeekCount: 24,
                zoomLevel5WeekCount: 48,
                selectedItemEnum: 0
            }
        },
        methods: {
            mouseUp() {
                if (this.zoomLevel == 1) {
                    this.setMaximizeGraphData(this.graphDataFromBackend);
                } else if (this.zoomLevel == 2) {
                    this.setMaximizeGraphData(this.graphDataFromBackend);
                } else if (this.zoomLevel == 3) {
                    this.setMaximizeGraphData(this.graphWeeklyDataFromBackend);
                } else if (this.zoomLevel == 4) {
                    this.setMaximizeGraphData(this.graphWeeklyDataFromBackend);
                } else if (this.zoomLevel == 5) {
                    this.setMaximizeGraphData(this.graphWeeklyDataFromBackend);
                }
            },
            maximizeGraphRender(status) {
                this.maximizeGraphRendered = status;
                this.$emit("renderedMaximize", status);
            },
            graphDragHandler(startDay, endDay) {
                if (this.zoomLevel === 1) {
                    if (endDay.isAfter(moment().add(-1, 'days'))) {
                        return;
                    }
                }
                else if (this.zoomLevel === 2) {
                    if (endDay.isAfter(moment().add(-1, 'days'))) {
                        return;
                    }
                }
                else if (this.zoomLevel === 3) {
                    if (endDay.isAfter(moment().add(-1, 'weeks'))) {
                        return;
                    }
                }
                else if (this.zoomLevel === 4) {
                    if (endDay.isAfter(moment().add(-1, 'weeks'))) {
                        return;
                    }
                }
                else if (this.zoomLevel === 5) {
                    if (endDay.isAfter(moment().add(-1, 'weeks'))) {
                        return;
                    }
                }
                this.startDay = startDay;
                this.endDay = endDay;
            },
            adjustShownDates() {
                if (this.zoomLevel === 1) {
                    this.startDay = moment().add((-1 * this.zoomLevel1DayCount), 'days');
                    this.endDay = moment().add((-1), 'days');
                } else if (this.zoomLevel === 2) {
                    this.startDay = moment().add((-1 * this.zoomLevel2DayCount), 'days');
                    this.endDay = moment().add((-1), 'days');
                } else if (this.zoomLevel === 3) {
                    let computeEndDay = moment().startOf('isoWeek');
                    this.startDay = moment(computeEndDay).add((-1 * this.zoomLevel3WeekCount), 'weeks');
                    this.endDay = computeEndDay;
                } else if (this.zoomLevel === 4) {
                    let computeEndDay = moment().startOf('isoWeek');
                    this.endDay = computeEndDay;
                    this.startDay = moment(this.endDay).add((-1 * this.zoomLevel4WeekCount), 'weeks');
                } else if (this.zoomLevel === 5) {
                    let computeEndDay = moment().startOf('isoWeek');
                    this.endDay = computeEndDay;
                    this.startDay = moment(this.endDay).add((-1 * this.zoomLevel5WeekCount), 'weeks');
                }
            },
            dateEqualityCompare(tempDay) {
                return (tempDay.format('MM-DD-YY') === this.startDay.format('MM-DD-YY')) || (tempDay.format('MM-DD-YY') === this.endDay.format('MM-DD-YY'));
            },
            setMaximizeGraphData(data) {
                // console.log("setting graph data");
                let tempDataForGraph = [];
                this.fetchData = false;
                this.loading = true;
                let feed_count = 0;
                if (this.zoomLevel >= 3) {
                    feed_count = TOTAL_WEEKLY_FEED_COUNT;
                }
                else {
                    feed_count = TOTAL_FEED_COUNT;
                }
                for (let i = 0; i < constants.risk_group_array.length; i++) {
                    this.selectedItemEnum = i + 1;
                    this.adjustMaxRadius();
                    if (this.zoomLevel >= 3) {
                        this.getWeeklyMaxCountHelper(this.graphWeeklyDataFromBackend);
                    } else if (this.zoomLevel < 3) {
                        this.getMaxCountHelper(this.graphDataFromBackend);
                    }
                    let oneRiskGroupSlice = data.filter(oneData => oneData.threat_risk_group_enum_no === i + 1);
                    let sub_risk_array = constants.risk_group_array.filter(oneData => oneData.enum_no === i + 1)[0].sub_risks;
                    oneRiskGroupSlice.map(oneData => {
                        if (this.dateEqualityCompare(moment(oneData.date)) || moment(oneData.date).isBetween(this.startDay, this.endDay)) {
                            let radius = 0;
                            if (this.zoomLevel >= 3) {
                                radius = this.getWeeklyLogarithmicRadius(parseInt(oneData.count));
                            }
                            else {
                                radius = this.getLogarithmicRadius(parseInt(oneData.count));
                            }
                            let obj = {
                                enumNo: oneData.threat_risk_group_enum_no,
                                label: parseInt(oneData.count),
                                data: [{
                                    x: moment(oneData.date).format(),
                                    y: sub_risk_array.filter(oneSubrisk => oneSubrisk.enum_no === oneData.threat_enum_no)[0].graph_value,
                                    r: radius
                                }],
                                backgroundColor: "rgba(255,71,58,0.8)",
                                hoverBackgroundColor: "rgba(255,71,58,0.7)",
                                hoverRadius: 1
                            };
                            tempDataForGraph.push(obj)
                        }
                    });
                }
                this.dataForGraph[0] = tempDataForGraph.filter(oneData => oneData.enumNo === 1);
                this.dataForGraph[1] = tempDataForGraph.filter(oneData => oneData.enumNo === 2);
                this.dataForGraph[2] = tempDataForGraph.filter(oneData => oneData.enumNo === 3);
                this.dataForGraph[3] = tempDataForGraph.filter(oneData => oneData.enumNo === 4);
                this.dataForGraph[4] = tempDataForGraph.filter(oneData => oneData.enumNo === 5);
                this.fetchData = true;
                this.loading = false;
            },
            getBaseLog(base, count) {
                if (count === 1) {
                    return 1;
                }
                return Math.log(count) / Math.log(base)
            },
            getLogarithmicRadius(count) {
                return count ? this.getBaseLog(this.logarithmicBase, count) : 0;
            },
            adjustMaxRadius() {
                let widthOfCanvas = document.getElementById("threat-timeline-maximize").clientWidth;
                if (this.zoomLevel === 1) {
                    this.maxRadius = (widthOfCanvas / this.zoomLevel1DayCount) - 16;
                    if (this.selectedItemEnum === 1) {
                        this.maxRadius = (this.maxRadius / 2) + 6;
                    } else if (this.selectedItemEnum === 3) {
                        this.maxRadius = (this.maxRadius / 4) + 2;
                    } else if (this.selectedItemEnum === 4) {
                        this.maxRadius = (this.maxRadius / 2) + 6;
                    }
                } else if (this.zoomLevel === 2) {
                    this.maxRadius = (widthOfCanvas / this.zoomLevel2DayCount) / 2 + 12;
                    if (this.selectedItemEnum === 3) {
                        this.maxRadius = (this.maxRadius / 2) + 4;
                    }
                } else if (this.zoomLevel === 3) {
                    this.maxRadius = (widthOfCanvas / this.zoomLevel3WeekCount) - 20;
                    if (this.selectedItemEnum === 1) {
                        this.maxRadius = (this.maxRadius / 2);
                    } else if (this.selectedItemEnum === 4) {
                        this.maxRadius = (this.maxRadius / 2);
                    } else if (this.selectedItemEnum === 3) {
                        this.maxRadius = (this.maxRadius / 4) - 2;
                    }
                } else if (this.zoomLevel === 4) {
                    this.maxRadius = (widthOfCanvas / this.zoomLevel4WeekCount) - 12;
                    if (this.selectedItemEnum === 3) {
                        this.maxRadius = (this.maxRadius / 2) - 1;
                    }
                } else if (this.zoomLevel === 5) {
                    this.maxRadius = (widthOfCanvas / this.zoomLevel5WeekCount) - 6;
                    if (this.selectedItemEnum === 3) {
                        this.maxRadius = this.maxRadius - 6;
                    }
                }
            },
            getMaxCountHelper(data) {
                let oneSlice = data.filter(oneData => oneData.threat_risk_group_enum_no === this.selectedItemEnum);
                let max = oneSlice.reduce((max, oneData) => oneData.count > max ? oneData.count : max, oneSlice[0].count);
                this.logarithmicBase = Math.pow(max, 1 / this.maxRadius);
            },
            getWeeklyMaxCountHelper(data) {
                let oneSlice = data.filter(oneData => oneData.threat_risk_group_enum_no === this.selectedItemEnum);
                let max = oneSlice.reduce((max, oneData) => parseInt(oneData.count) > max ? parseInt(oneData.count) : max, parseInt(oneSlice[0].count));
                this.logarithmicBaseWeekly = Math.pow(max, 1 / this.maxRadius);
            },
            getWeeklyLogarithmicRadius(count) {
                return count ? this.getBaseLog(this.logarithmicBaseWeekly, count) : 0;
            },
            changeZoomLevel(e) {
                if (e.deltaY < 0) {
                    if (this.zoomLevel === 5) {
                        this.zoomLevel = 5;
                        this.setMaximizeZoomLevelIndex(5);
                        this.adjustShownDates();
                    }
                    else {
                        this.zoomLevel++;
                        this.setMaximizeZoomLevelIndex(this.zoomLevel);
                        this.adjustShownDates();
                    }
                }
                else {
                    if (this.zoomLevel === 1) {
                        this.zoomLevel = 1;
                        this.setMaximizeZoomLevelIndex(1);
                        this.adjustShownDates();
                    }
                    else {
                        this.zoomLevel--;
                        this.setMaximizeZoomLevelIndex(this.zoomLevel);
                        this.adjustShownDates();
                    }
                }
            },
            getThreatNames() {
                this.threatNames = constants.risk_group_array;
                this.screenBoolean = this.largeScreenBoolean;
            },
            getGraphData() {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/threat_timeline';
                let dailyBody = {
                    "group_by": "daily"
                };
                this.loading = true;
                this.$http.post(path, dailyBody).then(response => {
                    // this.getWeeklyGraphData();
                    this.graphDataFromBackend = response.body.data;
                    this.setMaximizeGraphData(response.body.data);
                    this.loading = false;
                }, response => {
                });
            },
            getWeeklyGraphData() {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/threat_timeline';
                let weeklyBody = {
                    "group_by": "weekly"
                };
                this.$http.post(path, weeklyBody).then(response => {
                    this.graphWeeklyDataFromBackend = response.body.data;
                })
            },
            setMaximizeZoomLevel() {
                this.setMaximizeZoomLevelIndex(2);
            },
            ...mapActions([
                "setMaximizeZoomLevelIndex"
            ])
        },
        computed: {
            ...mapGetters([
                "getMaximizeZoomLevelIndex"
            ])
        },
        watch: {
            zoomLevel: function () {
                if (this.zoomLevel == 1) {
                    this.adjustShownDates();
                    this.setMaximizeGraphData(this.graphDataFromBackend);
                    this.graphLabel = '14 days';
                } else if (this.zoomLevel == 2) {
                    this.adjustShownDates();
                    this.setMaximizeGraphData(this.graphDataFromBackend);
                    this.graphLabel = '30 days';
                } else if (this.zoomLevel == 3) {
                    this.adjustShownDates();
                    this.setMaximizeGraphData(this.graphWeeklyDataFromBackend);
                    this.graphLabel = '12 weeks';
                } else if (this.zoomLevel == 4) {
                    this.adjustShownDates();
                    this.setMaximizeGraphData(this.graphWeeklyDataFromBackend);
                    this.graphLabel = '24 weeks';
                } else if (this.zoomLevel == 5) {
                    this.adjustShownDates();
                    this.setMaximizeGraphData(this.graphWeeklyDataFromBackend);
                    this.graphLabel = '48 weeks';
                }
            }
        },
        mounted() {
        },
        beforeMount() {
            this.setMaximizeZoomLevel();
            this.adjustShownDates();
            this.getThreatNames();
            this.getWeeklyGraphData();
            this.getGraphData();
        }
    }
</script>

<style scoped>

    .graph-time-container {
        position: absolute;
        top: 60px;
        left: 90px;
        color: white;
        font-weight: bold;
    }

    .scroll {
        overflow-y: scroll;
        height: 930px;
    }

    .scroll::-webkit-scrollbar {
        display: none;
    }

    .threat-timeline-header {
        height: 50px;
        background-color: #FB2C37;
        background-image: linear-gradient(to left, #FB2C37, black);
        border-bottom: 1px solid #b28584;
        font-family: Digital-Serial-Bold;
        color: white;
        font-size: 25px;
        padding: 10px;
    }

    .threat-timeline-graph {
        margin-top: 25px;
        margin-bottom: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/threat-timeline/ThreatTimeLineMaximize.vue